import { render, staticRenderFns } from "./body_f_selected.vue?vue&type=template&id=9d45ce50"
import script from "./body_f_selected.vue?vue&type=script&lang=js"
export * from "./body_f_selected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports